var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g2, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _g3, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _g4, _g5, _g6, _path90, _path91, _path92, _g7, _path93, _path94;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 823.452,
    height: 353.923,
    viewBox: "0 0 823.452 353.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24728",
    "data-name": "Path 24728",
    d: "M352.312,230.632c-28.783,22.318-46.495,57.272-57.945,91.137a1.166,1.166,0,0,0,.382,1.361c4.338,2.689,8.95,3.951,13.71,1.935a.95.95,0,0,0,.781-.694l.013-.029.006-.023a362.521,362.521,0,0,1,13.319-34.262c8.417-19.1,18.539-40.243,34.958-53.785a1.158,1.158,0,0,0,.179-1.628q-1.884-1.921-3.77-3.833a1.328,1.328,0,0,0-.934-.428,1.135,1.135,0,0,0-.7.249",
    transform: "translate(-294.294 -230.383)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24763",
    "data-name": "Path 24763",
    d: "M279.338,216.256q-2.726,1.5-5.448,3.01a1.345,1.345,0,0,0-.333,1.867c13.767,20.433,18.038,47.23,21.1,71.2a420.134,420.134,0,0,1,3.508,42.4c0,.006,0,.019,0,.026a.058.058,0,0,0,0,.037,1.092,1.092,0,0,0,.635,1.027c4.622,3.8,10.156,3.922,15.852,2.365a1.359,1.359,0,0,0,.876-1.384c-1.567-41.353-9.723-85.968-34.321-120.214a1.279,1.279,0,0,0-1.062-.555,1.709,1.709,0,0,0-.81.22",
    transform: "translate(-273.324 -216.036)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14276",
    "data-name": "Group 14276",
    transform: "translate(-382.575 -475.415)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24682",
    "data-name": "Path 24682",
    d: "M258.365,39.7a1.185,1.185,0,0,0,1.22-1.09,1.138,1.138,0,0,0-.663-1.351,1.06,1.06,0,0,0-.281-.092c-4-.975-7.155-5.8-11.31-5.861-3.55-.049-6.194-.663-7.9-4.068a16.126,16.126,0,0,0-2.708-4.072c-2.123-2.23-4.943-2.511-7.773-2.1-2.043.3-3.979.247-6.02.367-1.133.064-3.5-4.82-4.023-5.664C214.529,8.7,210.342,1.111,201.157.136a25.2,25.2,0,0,0-20.745,7.795c-4.019-3.751-7.4-7.767-13.557-4.775a14.337,14.337,0,0,0-7.079,7.224,18.978,18.978,0,0,1-3.173,5.176c-1.962,2.086-5.877.872-8.318.847-3.19-.034-5.286,2.548-7.093,4.8-2.216,2.763-4.258,2.969-7.517,1.94a5.6,5.6,0,0,0-3.709.166c-5.9,3.174-7.3,13.185-14.981,13.83a1.282,1.282,0,0,0,0,2.562h143.38Z",
    transform: "translate(485.908 475.414)",
    fill: "#e6f5f6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24683",
    "data-name": "Path 24683",
    d: "M286.244,70.014H389.476a.89.89,0,1,0,0-1.779c-5.57-.452-6.579-7.416-10.855-9.623a4.253,4.253,0,0,0-2.691-.114c-2.362.716-3.84.572-5.447-1.351-1.308-1.563-2.829-3.36-5.143-3.337-1.767.017-4.607.865-6.026-.589a13.077,13.077,0,0,1-2.3-3.6,10.2,10.2,0,0,0-5.13-5.025c-4.465-2.081-6.913.712-9.824,3.32a18.7,18.7,0,0,0-15.036-5.42c-6.66.677-9.693,5.953-12.867,10.872-.378.587-2.095,3.985-2.914,3.942-1.483-.083-2.881-.05-4.366-.256-2.051-.284-4.094-.088-5.633,1.462a11.208,11.208,0,0,0-1.961,2.833c-1.237,2.367-3.153,2.795-5.728,2.828-3.01.045-5.3,3.4-8.2,4.077a.808.808,0,0,0-.2.066.781.781,0,0,0-.478.939.845.845,0,0,0,.882.757Z",
    transform: "translate(815.655 470.066)",
    fill: "#e6f5f6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24684",
    "data-name": "Path 24684",
    d: "M177.977,216.868a1.176,1.176,0,0,0-.242-.042,56.425,56.425,0,0,1-14.374-3.739c-3.949-1.733-6.374-5.521-10.373-7.248-2.857-1.231-6.658-.289-8.362-3.19-2.107-3.59-2.779-7.914-4.719-11.614-3.385-6.421-10.784-8.156-17.371-7.188-7.948,1.168-12.563,7.581-17.194,13.443-3.086-4.961-7.524-8.614-13.9-7.441-8.094,1.486-10.31,7.49-13.44,14.018-8.055-5.8-18.368-4.29-20.969,6.184-5.646-.362-13.268,1.834-13.653,8.229a1.476,1.476,0,0,0,1.47,1.467H177.574a1.373,1.373,0,0,0,1.413-1.335,1.188,1.188,0,0,0-1.009-1.545",
    transform: "translate(974.138 293.591)",
    fill: "#e6f5f6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24685",
    "data-name": "Path 24685",
    d: "M311.632,156.662a1.275,1.275,0,0,0,1.312,1.243h123.67a1.376,1.376,0,0,0,1.369-1.368c-.359-5.959-7.463-8.006-12.72-7.669-2.424-9.758-12.033-11.17-19.54-5.758-2.918-6.085-4.979-11.681-12.521-13.066-5.947-1.093-10.082,2.31-12.957,6.933-4.312-5.46-8.613-11.436-16.016-12.524-6.14-.9-13.038.714-16.186,6.7-1.808,3.444-2.435,7.474-4.4,10.82-1.589,2.7-5.127,1.825-7.79,2.972-3.728,1.609-5.988,5.138-9.666,6.754a52.465,52.465,0,0,1-13.393,3.483,1.692,1.692,0,0,0-.226.037,1.106,1.106,0,0,0-.938,1.443",
    transform: "translate(70.983 415.858)",
    fill: "#e6f5f6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24686",
    "data-name": "Path 24686",
    d: "M679.1,311.2c0,47.424-66.35,35.949-69.813,68.528-3.222,30.279,42.657,28.817,49.151,50.517,12.038,40.228-61.267,50.347-81.869,51.966-53.571,4.218-100.7,2.293-141.825-1.449-13.042-.938-55.513-.084-57.175-14.035-2.01-16.835,23.147-11.249,23.947-22.452,1-14.03-40.94-14.046-63.178-12.913-42.045,2.139-68.1-.179-108.231,2.627-21.065.931-88.27,3.74-87.268-26.2.312-9.395,16.85-13.569,18.054-20.58,2.844-16.522-49.153-15.9-62.193-14.97C64.593,374.11,4.168,368.729.4,342.3c-5.683-39.827,51.157-43.722,70.217-44.655,43.129,0,84.259.013,128.4-3.741,9.838-.839,20.064-.254,18.059-11.481-2.006-7.481-16.053-10.287-17.054-17.773C196,233.783,305.968,229.177,363.525,234.477c61.611,5.667,95.971,8.658,70.895,33.92-20.6,20.753,244.682-11.22,244.682,42.8",
    transform: "translate(465.396 344.741)",
    fill: "#c5e1e9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24687",
    "data-name": "Path 24687",
    d: "M398.154,331.745c-5.266-32.765-40.018-62.8-73.163-63.1-34.177-.312-65.534,30.5-75.257,61.375a5.716,5.716,0,0,0,2.647,6.483c23.189,11.662,49.457,15.277,75.2,15.136,22.646-.128,48.192-1.006,67.935-13.409a5.411,5.411,0,0,0,2.685-4.929,6.285,6.285,0,0,0-.042-1.56",
    transform: "translate(619.286 366.98)",
    fill: "#e9a83f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24688",
    "data-name": "Path 24688",
    d: "M273.611,290.64a1.976,1.976,0,0,1-1.816,1.812,1.822,1.822,0,1,1,0-3.625,1.976,1.976,0,0,1,1.816,1.812",
    transform: "translate(631.787 379.427)",
    fill: "#b77a49"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24689",
    "data-name": "Path 24689",
    d: "M280.839,291.766a1.973,1.973,0,0,1-1.812,1.814,1.825,1.825,0,1,1,0-3.631,1.976,1.976,0,0,1,1.812,1.817",
    transform: "translate(636.245 380.118)",
    fill: "#b77a49"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24690",
    "data-name": "Path 24690",
    d: "M333.323,306.375a1.977,1.977,0,0,1-1.819,1.812,1.824,1.824,0,1,1,0-3.628,1.98,1.98,0,0,1,1.819,1.816",
    transform: "translate(668.614 389.129)",
    fill: "#b77a49"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24691",
    "data-name": "Path 24691",
    d: "M330.955,288.043a1.977,1.977,0,0,1-1.814,1.817,1.825,1.825,0,1,1,0-3.631,1.976,1.976,0,0,1,1.814,1.814",
    transform: "translate(667.153 377.824)",
    fill: "#b77a49"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24692",
    "data-name": "Path 24692",
    d: "M258.146,307.2a1.973,1.973,0,0,1-1.811,1.812,1.824,1.824,0,1,1,0-3.63,1.975,1.975,0,0,1,1.811,1.817",
    transform: "translate(622.252 389.637)",
    fill: "#b77a49"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24693",
    "data-name": "Path 24693",
    d: "M321,313.7a1.976,1.976,0,0,1-1.814,1.814,1.824,1.824,0,1,1,0-3.628A1.976,1.976,0,0,1,321,313.7",
    transform: "translate(661.016 393.646)",
    fill: "#b77a49"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24694",
    "data-name": "Path 24694",
    d: "M281.43,308.622a1.974,1.974,0,0,1-1.811,1.812,1.826,1.826,0,1,1,0-3.631,1.98,1.98,0,0,1,1.811,1.819",
    transform: "translate(636.609 390.513)",
    fill: "#b77a49"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24695",
    "data-name": "Path 24695",
    d: "M282.957,284.447a1,1,0,0,1-.912.909.913.913,0,1,1,0-1.817.992.992,0,0,1,.912.909",
    transform: "translate(638.728 376.164)",
    fill: "#b77a49"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24696",
    "data-name": "Path 24696",
    d: "M276.081,287.139a.991.991,0,0,1-.905.905.913.913,0,1,1,0-1.816.988.988,0,0,1,.905.91",
    transform: "translate(634.49 377.824)",
    fill: "#b77a49"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24697",
    "data-name": "Path 24697",
    d: "M319.686,286.575a.992.992,0,0,1-.912.909.913.913,0,1,1,0-1.816.992.992,0,0,1,.912.907",
    transform: "translate(661.381 377.478)",
    fill: "#b77a49"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24698",
    "data-name": "Path 24698",
    d: "M296.238,307.712a.994.994,0,0,1-.907.907.913.913,0,1,1,0-1.816.99.99,0,0,1,.907.909",
    transform: "translate(646.919 390.513)",
    fill: "#b77a49"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24699",
    "data-name": "Path 24699",
    d: "M267.047,304.9a.99.99,0,0,1-.905.909.914.914,0,1,1,0-1.817.987.987,0,0,1,.905.909",
    transform: "translate(628.918 388.782)",
    fill: "#b77a49"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24700",
    "data-name": "Path 24700",
    d: "M316.481,278.523a.99.99,0,0,1-.909.905.913.913,0,1,1,0-1.816.988.988,0,0,1,.909.91",
    transform: "translate(659.405 372.51)",
    fill: "#b77a49"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24701",
    "data-name": "Path 24701",
    d: "M289.083,317.7a.989.989,0,0,1-.905.909.913.913,0,1,1,0-1.816.986.986,0,0,1,.905.907",
    transform: "translate(642.508 396.675)",
    fill: "#b77a49"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24702",
    "data-name": "Path 24702",
    d: "M264.2,305.467a.99.99,0,0,1-.905.907.913.913,0,1,1,0-1.816.987.987,0,0,1,.905.909",
    transform: "translate(627.165 389.128)",
    fill: "#b77a49"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24703",
    "data-name": "Path 24703",
    d: "M323.826,297.065a.993.993,0,0,1-.909.909.914.914,0,1,1,0-1.819.988.988,0,0,1,.909.91",
    transform: "translate(663.935 383.946)",
    fill: "#b77a49"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24704",
    "data-name": "Path 24704",
    d: "M304.485,297.627a.994.994,0,0,1-.907.907.913.913,0,1,1,0-1.816.989.989,0,0,1,.907.909",
    transform: "translate(652.007 384.293)",
    fill: "#b77a49"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24705",
    "data-name": "Path 24705",
    d: "M292.552,294.664a.99.99,0,0,1-.909.907.913.913,0,1,1,0-1.816.986.986,0,0,1,.909.909",
    transform: "translate(644.647 382.465)",
    fill: "#b77a49"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24706",
    "data-name": "Path 24706",
    d: "M300.928,307.149a.989.989,0,0,1-.905.909.913.913,0,1,1,0-1.816.989.989,0,0,1,.905.907",
    transform: "translate(649.816 390.167)",
    fill: "#b77a49"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24707",
    "data-name": "Path 24707",
    d: "M296.83,274.731a.987.987,0,0,1-.907.905.913.913,0,1,1,0-1.816.988.988,0,0,1,.907.91",
    transform: "translate(647.285 370.171)",
    fill: "#b77a49"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24708",
    "data-name": "Path 24708",
    d: "M281.294,275.856a.993.993,0,0,1-.909.907.914.914,0,1,1,0-1.819.991.991,0,0,1,.909.912",
    transform: "translate(637.704 370.864)",
    fill: "#b77a49"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24709",
    "data-name": "Path 24709",
    d: "M357.715,234.643q-1.882-1.918-3.77-3.832a1.187,1.187,0,0,0-1.633-.179c-28.785,22.318-46.5,57.27-57.946,91.137a1.162,1.162,0,0,0,.385,1.36c4.336,2.69,8.949,3.953,13.708,1.937a.95.95,0,0,0,.781-.694l.011-.031a.048.048,0,0,0,.008-.021,362.738,362.738,0,0,1,13.319-34.264c8.418-19.1,18.538-40.241,34.959-53.785a1.16,1.16,0,0,0,.178-1.628",
    transform: "translate(646.903 343.38)",
    fill: "#865936"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13255",
    "data-name": "Group 13255",
    transform: "translate(941.196 573.763)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24710",
    "data-name": "Path 24710",
    d: "M295.174,276.989a200.9,200.9,0,0,0,13.539,21.526c.348.488,1.07-.1.723-.58a199.876,199.876,0,0,1-13.416-21.322c-.276-.522-1.13-.154-.846.377",
    transform: "translate(-293.786 -202.026)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24711",
    "data-name": "Path 24711",
    d: "M297.831,272.095c3.866,9.542,10.5,17.43,15.825,26.138.307.511,1.033-.073.723-.574-5.275-8.642-11.867-16.476-15.7-25.938-.221-.555-1.072-.18-.846.373",
    transform: "translate(-292.135 -205.056)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24712",
    "data-name": "Path 24712",
    d: "M300.468,266.334c4.467,6.763,7.966,14.066,11.88,21.152.285.517,1.133.147.844-.375-3.947-7.153-7.487-14.528-12-21.356-.328-.5-1.052.081-.723.579",
    transform: "translate(-290.537 -208.685)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24713",
    "data-name": "Path 24713",
    d: "M304.465,261.579c4.457,6.372,8.1,13.227,12.016,19.925.3.508,1.153.141.849-.377-3.958-6.766-7.639-13.694-12.14-20.125-.346-.491-1.065.091-.724.577",
    transform: "translate(-288.075 -211.613)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24714",
    "data-name": "Path 24714",
    d: "M308.215,251.511a181.889,181.889,0,0,0,10.777,23.3c.276.529,1.132.155.846-.372a182.2,182.2,0,0,1-10.776-23.3c-.2-.561-1.049-.186-.847.38",
    transform: "translate(-285.727 -217.758)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24715",
    "data-name": "Path 24715",
    d: "M313.309,243.8c2.713,8.372,6.564,16.269,10.367,24.188.26.54,1.109.163.847-.375-3.8-7.922-7.652-15.822-10.365-24.19-.186-.571-1.031-.191-.849.377",
    transform: "translate(-282.582 -222.512)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24716",
    "data-name": "Path 24716",
    d: "M318.019,239.516c2.053,6.865,3.846,13.791,6.755,20.363a.464.464,0,0,0,.847-.378c-2.91-6.567-4.7-13.5-6.753-20.36-.17-.571-1.017-.189-.849.375",
    transform: "translate(-279.674 -225.156)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24717",
    "data-name": "Path 24717",
    d: "M321.849,234.555c2.083,6.113,3.948,12.3,6.035,18.412.192.567,1.036.191.849-.378-2.081-6.111-3.955-12.3-6.037-18.412-.192-.564-1.036-.189-.847.378",
    transform: "translate(-277.315 -228.216)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24718",
    "data-name": "Path 24718",
    d: "M326.734,230.478c1.665,4.939,3.321,9.883,4.875,14.861.176.572,1.023.192.846-.375-1.552-4.98-3.2-9.92-4.876-14.86-.186-.569-1.035-.191-.844.373",
    transform: "translate(-274.303 -230.729)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24719",
    "data-name": "Path 24719",
    d: "M290.792,289.054c10.677-1.227,20.859-4.663,31.294-7.083.579-.134.436-1.052-.147-.92-10.43,2.424-20.619,5.861-31.292,7.086-.593.071-.445.986.145.917",
    transform: "translate(-296.776 -199.141)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24720",
    "data-name": "Path 24720",
    d: "M290.521,284.341c12.122-2.807,23.784-7.077,35.577-11.008.566-.191.184-1.036-.38-.85-11.709,3.9-23.3,8.153-35.344,10.939-.579.136-.438,1.056.147.92",
    transform: "translate(-296.939 -204.434)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24721",
    "data-name": "Path 24721",
    d: "M293.553,275.535c12.226.37,23.349-4.32,34.9-7.629.566-.163.427-1.08-.147-.918-11.451,3.28-22.531,7.992-34.652,7.628-.593-.021-.7.905-.1.92",
    transform: "translate(-294.998 -207.819)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24722",
    "data-name": "Path 24722",
    d: "M297.627,269.558c11.6-2.238,23.021-5.2,34.5-7.969.576-.142.437-1.057-.144-.915-11.479,2.77-22.906,5.731-34.5,7.969-.582.112-.443,1.028.146.915",
    transform: "translate(-292.557 -211.71)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24723",
    "data-name": "Path 24723",
    d: "M300.164,264.968c12.81-3.531,25.622-7.051,38.5-10.325.571-.149.435-1.067-.147-.917-12.878,3.276-25.694,6.8-38.5,10.326-.568.157-.428,1.074.149.915",
    transform: "translate(-290.988 -215.996)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24724",
    "data-name": "Path 24724",
    d: "M305.055,255.656c9.988-1.748,19.931-3.748,29.887-5.686.584-.112.446-1.031-.146-.915-9.956,1.937-19.9,3.934-29.891,5.688a.463.463,0,0,0,.149.913",
    transform: "translate(-287.979 -218.873)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24725",
    "data-name": "Path 24725",
    d: "M309.426,248.746c9.817-2.17,19.849-2.834,29.753-4.456a.464.464,0,0,0-.147-.915c-9.9,1.625-19.935,2.286-29.75,4.454-.58.124-.44,1.041.144.917",
    transform: "translate(-285.278 -222.375)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24726",
    "data-name": "Path 24726",
    d: "M314.885,240.573c8.915.008,17.8-.766,26.7-1.08.6-.021.443-.936-.149-.913-8.819.307-17.615,1.078-26.449,1.07-.59,0-.7.923-.105.923",
    transform: "translate(-281.838 -225.328)",
    fill: "#946641"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24727",
    "data-name": "Path 24727",
    d: "M318.078,235.714c9.093,1.795,18.31,1.478,27.529,1.518.593,0,.7-.918.1-.923-9.22-.039-18.434.28-27.53-1.52-.585-.115-.682.807-.1.925",
    transform: "translate(-279.865 -227.672)",
    fill: "#946641"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24729",
    "data-name": "Path 24729",
    d: "M345.194,238.387a7.267,7.267,0,0,1-7.374,5.89c-3.256-.365-6.975-4.189-6.611-7.453s4.836-6.171,8.1-5.807a7.269,7.269,0,0,1,5.89,7.371",
    transform: "translate(669.656 343.751)",
    fill: "#6b4c34"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24730",
    "data-name": "Path 24730",
    d: "M333.091,237.758a7.27,7.27,0,0,1-7.372,5.89c-3.259-.365-6.976-4.192-6.613-7.453s4.834-6.171,8.1-5.811a7.273,7.273,0,0,1,5.89,7.374",
    transform: "translate(662.191 343.362)",
    fill: "#6b4c34"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24731",
    "data-name": "Path 24731",
    d: "M375.928,235.469a16.332,16.332,0,0,1,1.319,8.635,104.237,104.237,0,0,1,17.608,7.723,17.847,17.847,0,0,0,1.634-6.124,26.571,26.571,0,0,1,2.346,8.485,54.538,54.538,0,0,1,13.8,11.755c2.829-14.192.813-28.005-8.273-37.061a21.206,21.206,0,0,0-5.72,3.7,13.594,13.594,0,0,1,3.285-5.858c-5.8-4.639-13.911-7.647-24.732-8.242a37.727,37.727,0,0,0-5.866,7.6,33.066,33.066,0,0,1,.475-7.613c-17.319,1.234-37.6,14.661-42.914,28.187,9.041-9.1,27.084-8.836,44.513-3.749a18.965,18.965,0,0,0,2.525-7.437",
    transform: "translate(668.241 336.032)",
    fill: "#7a8a44"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24732",
    "data-name": "Path 24732",
    d: "M368.449,224.22a41.368,41.368,0,0,0-14.384,2,52.132,52.132,0,0,0-11.6,5.345,55.336,55.336,0,0,0-13.573,11.573,75.223,75.223,0,0,1,14.25-10.417c6.619-3.676,15.443-7.07,25.234-6.645a45.428,45.428,0,0,1,24.449,8.916,100.058,100.058,0,0,1,13.261,11.7,67.32,67.32,0,0,0-12.467-12.771,44.078,44.078,0,0,0-25.168-9.694",
    transform: "translate(668.241 339.553)",
    fill: "#6c793c"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24733",
    "data-name": "Path 24733",
    d: "M379.274,223.782a15.8,15.8,0,0,1,4.9,7.73,149.247,149.247,0,0,1,22.943,1.536,15.186,15.186,0,0,0-.572-6.328,27.528,27.528,0,0,1,6,7.254c7.909,1.538,14.937,3.751,20.229,6.592-2.4-14.336-10.135-26.73-23.972-32.313a21.888,21.888,0,0,0-5.006,5.369,11.64,11.64,0,0,1,1.4-6.608c-8.384-2.488-18.737-2.672-31.2.3a33.811,33.811,0,0,0-3.626,9.1,29.32,29.32,0,0,1-2.469-7.351c-19.079,6.837-36.7,26.164-37.363,40.682,6.624-11.555,27.115-17.215,48.816-18.117a15.917,15.917,0,0,0-.081-7.854",
    transform: "translate(669.257 327.797)",
    fill: "#7a8a44"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24734",
    "data-name": "Path 24734",
    d: "M367.766,214.308a53.4,53.4,0,0,0-15.458,6.6,58.485,58.485,0,0,0-11,8.844,53.665,53.665,0,0,0-10.768,15.382,75.815,75.815,0,0,1,11.988-14.51,59.164,59.164,0,0,1,25.889-14.538c11.2-2.82,22.452-1.782,31.145.422a134.5,134.5,0,0,1,19.6,6.708,88.154,88.154,0,0,0-19.129-7.985,62.662,62.662,0,0,0-32.266-.92",
    transform: "translate(669.258 332.42)",
    fill: "#6c793c"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24735",
    "data-name": "Path 24735",
    d: "M368.665,259.237a12.876,12.876,0,0,1-3.109,6.845,127.968,127.968,0,0,1,9.262,16.829,12.124,12.124,0,0,0,4.1-3.182,22.612,22.612,0,0,1-2.291,7.413,62.376,62.376,0,0,1,4.566,17.138c8.779-8,13.828-18.887,11.437-31.085a18,18,0,0,0-5.943-1.159,9.288,9.288,0,0,1,5.177-1.926c-2.066-7-6.593-14.368-14.25-21.826a27.1,27.1,0,0,0-7.893,1.447,23.813,23.813,0,0,1,3.948-4.972c-13.293-10.426-34.51-14.333-44.791-8.41,10.924-.42,24.04,11.516,34.424,26.4a12.7,12.7,0,0,0,5.364-3.508",
    transform: "translate(668.233 345.348)",
    fill: "#7a8a44"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24736",
    "data-name": "Path 24736",
    d: "M366.828,248.08a45.272,45.272,0,0,0-11.5-7.984,48.583,48.583,0,0,0-11.036-3.858,43.855,43.855,0,0,0-15.421-.815,62.358,62.358,0,0,1,15.375,2.057A49.762,49.762,0,0,1,365.9,249.316a55.183,55.183,0,0,1,13.72,22.109,113.752,113.752,0,0,1,4.208,16.753,74.228,74.228,0,0,0-3.115-16.982,53.559,53.559,0,0,0-13.881-23.116",
    transform: "translate(668.232 346.273)",
    fill: "#6c793c"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24737",
    "data-name": "Path 24737",
    d: "M318.161,234.339a12.912,12.912,0,0,0-2.663,7.035,127.669,127.669,0,0,0-18.47,5.29,12.217,12.217,0,0,1-.627-5.151,22.664,22.664,0,0,0-3.644,6.852,62.13,62.13,0,0,0-15.374,8.84c-.516-11.862,3.647-23.121,13.988-30.025a17.93,17.93,0,0,1,5.01,3.4,9.305,9.305,0,0,0-2.28-5.03c6.419-3.468,14.835-5.45,25.521-5.277a26.908,26.908,0,0,1,4.54,6.621,23.672,23.672,0,0,0,.744-6.3c16.763,2.076,34.49,14.371,37.536,25.842-7.4-8.048-25.113-8.934-42.99-5.811a12.774,12.774,0,0,1-1.292-6.283",
    transform: "translate(636.447 337.138)",
    fill: "#7a8a44"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24738",
    "data-name": "Path 24738",
    d: "M323.3,225.322a45.108,45.108,0,0,1,13.765,2.525,48.7,48.7,0,0,1,10.512,5.107,43.833,43.833,0,0,1,11.447,10.367,62.3,62.3,0,0,0-12.294-9.461,49.7,49.7,0,0,0-23.655-7.005,55.187,55.187,0,0,0-25.354,5.851,113.761,113.761,0,0,0-14.847,8.819,74.343,74.343,0,0,1,14.242-9.754,53.449,53.449,0,0,1,26.183-6.449",
    transform: "translate(639.862 340.248)",
    fill: "#6c793c"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24739",
    "data-name": "Path 24739",
    d: "M326.079,224.137a16.446,16.446,0,0,0-5.382,6.883,104,104,0,0,0-19.128-1.885,18.034,18.034,0,0,1,1.568-6.15,26.643,26.643,0,0,0-6.2,6.254,54.457,54.457,0,0,0-17.788,3.491c4.485-13.759,13.01-24.816,25.364-28.258a21.022,21.022,0,0,1,3.172,6.024,13.6,13.6,0,0,0,.013-6.714c7.33-1.2,15.872.147,25.6,4.93a37.88,37.88,0,0,1,1.386,9.5A33.168,33.168,0,0,0,338,211.339c14.494,9.558,25.6,31.2,23.6,45.6-3.426-12.36-19.283-20.973-36.969-25.076a18.941,18.941,0,0,1,1.439-7.722",
    transform: "translate(637.565 326.717)",
    fill: "#7a8a44"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24740",
    "data-name": "Path 24740",
    d: "M331.272,216.016a41.257,41.257,0,0,1,11.557,8.789,51.987,51.987,0,0,1,7.5,10.338,55.543,55.543,0,0,1,6.163,16.743,75.235,75.235,0,0,0-7.321-16.064c-3.971-6.451-10-13.733-18.743-18.151a45.432,45.432,0,0,0-25.684-4.207,100.785,100.785,0,0,0-17.29,3.7,67.52,67.52,0,0,1,17.125-5.022,44.064,44.064,0,0,1,26.694,3.877",
    transform: "translate(642.684 331.766)",
    fill: "#6c793c"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24741",
    "data-name": "Path 24741",
    d: "M338.806,219.18a12.561,12.561,0,0,0-7.406-.173,129.1,129.1,0,0,0-11.269-15.555,11.6,11.6,0,0,1,4.53-2.294,22.4,22.4,0,0,0-7.574-1.151,63.42,63.42,0,0,0-13.472-11.485c10.759-4.406,22.578-4.221,32.516,3.18a17.652,17.652,0,0,1-1.4,5.822,8.874,8.874,0,0,0,3.841-3.8c5.419,4.868,10.161,12.1,13.705,22.175a26.24,26.24,0,0,1-4.533,6.438,22.742,22.742,0,0,0,6.064-1.384c3.892,16.391-1.306,37.074-10.821,43.722,4.853-9.6-.458-26.491-9.528-42.207a12.163,12.163,0,0,1,5.342-3.287",
    transform: "translate(652.651 315.755)",
    fill: "#7a8a44"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24742",
    "data-name": "Path 24742",
    d: "M341.619,222.526a45.75,45.75,0,0,1,2.436,13.733,48.812,48.812,0,0,1-1.072,11.54,42.929,42.929,0,0,1-5.587,14.156,61.312,61.312,0,0,0,4.454-14.649,50.032,50.032,0,0,0-1.72-24.486A56.367,56.367,0,0,0,325.954,201a116.007,116.007,0,0,0-13.266-11,75.252,75.252,0,0,1,13.92,10.118,54.705,54.705,0,0,1,15.01,22.408",
    transform: "translate(658.249 318.474)",
    fill: "#6c793c"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24743",
    "data-name": "Path 24743",
    d: "M339.445,240.306a7.264,7.264,0,0,1-7.372,5.891c-3.258-.369-6.973-4.189-6.611-7.453s4.834-6.171,8.1-5.807a7.261,7.261,0,0,1,5.888,7.369",
    transform: "translate(666.111 344.936)",
    fill: "#86593d"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24744",
    "data-name": "Path 24744",
    d: "M273.555,221.134c13.77,20.433,18.038,47.23,21.1,71.2a420.548,420.548,0,0,1,3.508,42.4c0,.008,0,.018,0,.026a.059.059,0,0,0,0,.037,1.091,1.091,0,0,0,.634,1.027c4.624,3.8,10.156,3.921,15.854,2.364a1.356,1.356,0,0,0,.876-1.384c-1.568-41.352-9.723-85.968-34.322-120.212a1.379,1.379,0,0,0-1.871-.335q-2.726,1.506-5.45,3.01a1.348,1.348,0,0,0-.333,1.867",
    transform: "translate(633.97 334.532)",
    fill: "#9b693c"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13259",
    "data-name": "Group 13259",
    transform: "translate(907.294 550.568)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24745",
    "data-name": "Path 24745",
    d: "M310.618,279.521a232.875,232.875,0,0,1-22.109,19.432c-.547.432-1.156-.458-.613-.878a231.3,231.3,0,0,0,21.9-19.251c.487-.488,1.31.207.818.7",
    transform: "translate(-264.468 -177.413)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24746",
    "data-name": "Path 24746",
    d: "M310.807,273.218c-7.424,9.316-17.387,15.885-26.159,23.8-.509.464-1.12-.42-.613-.876,8.7-7.856,18.594-14.381,25.96-23.622.43-.54,1.248.157.812.7",
    transform: "translate(-266.836 -181.32)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24747",
    "data-name": "Path 24747",
    d: "M307.581,265.952c-7.185,6.035-13.466,12.992-20.14,19.564-.492.482-1.314-.209-.816-.7,6.732-6.635,13.088-13.655,20.342-19.747.532-.445,1.141.44.614.881",
    transform: "translate(-265.216 -185.869)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24748",
    "data-name": "Path 24748",
    d: "M304.618,259.363c-7.039,5.6-13.338,12.011-19.893,18.155-.5.471-1.318-.223-.818-.7,6.621-6.207,12.986-12.683,20.1-18.339.54-.435,1.151.451.613.881",
    transform: "translate(-266.893 -189.929)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24749",
    "data-name": "Path 24749",
    d: "M303.629,246.952c-5.883,8.018-12.688,15.217-19.632,22.313-.477.49-1.3-.2-.815-.7,6.941-7.1,13.742-14.3,19.629-22.314.408-.553,1.229.141.818.7",
    transform: "translate(-267.335 -197.524)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24750",
    "data-name": "Path 24750",
    d: "M300.442,236.723c-5.762,8.4-12.64,15.9-19.464,23.433-.461.516-1.284-.183-.816-.7,6.828-7.532,13.7-15.034,19.464-23.433.393-.567,1.2.131.816.7",
    transform: "translate(-269.193 -203.837)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24751",
    "data-name": "Path 24751",
    d: "M294.608,230.418c-4.537,6.942-8.8,14.043-14.19,20.378a.538.538,0,0,1-.816-.7c5.385-6.33,9.655-13.435,14.187-20.373.382-.58,1.193.121.82.694",
    transform: "translate(-269.534 -207.728)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24752",
    "data-name": "Path 24752",
    d: "M291.438,223.649c-4.325,6.1-8.431,12.35-12.758,18.45-.4.564-1.214-.134-.815-.7,4.322-6.1,8.43-12.347,12.75-18.447.4-.567,1.221.131.823.694",
    transform: "translate(-270.59 -211.898)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24753",
    "data-name": "Path 24753",
    d: "M286.419,217.522c-3.474,4.931-6.938,9.875-10.3,14.887-.386.577-1.2-.124-.823-.7,3.365-5.012,6.829-9.958,10.3-14.889.4-.564,1.214.133.816.7",
    transform: "translate(-272.167 -215.678)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24754",
    "data-name": "Path 24754",
    d: "M316.35,298.279c-11.442-4.879-21.618-12.04-32.4-18.161-.6-.338-.141-1.311.461-.965,10.781,6.116,20.956,13.285,32.4,18.155.637.273.168,1.245-.466.972",
    transform: "translate(-266.941 -177.153)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24755",
    "data-name": "Path 24755",
    d: "M319.982,293.654c-12.533-7.1-24.073-15.678-35.858-23.925-.569-.4.131-1.213.694-.818,11.713,8.189,23.181,16.712,35.627,23.773.595.34.137,1.311-.462.97",
    transform: "translate(-266.794 -183.49)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24756",
    "data-name": "Path 24756",
    d: "M319.207,282.809c-13.691-3.612-24.491-12.481-36.215-19.954-.584-.364-.124-1.34.459-.968,11.626,7.411,22.378,16.282,35.945,19.867.663.175.477,1.232-.189,1.056",
    transform: "translate(-267.528 -187.808)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24757",
    "data-name": "Path 24757",
    d: "M316.536,274.8c-12.135-6.3-23.844-13.348-35.667-20.2-.6-.346-.137-1.316.462-.968,11.827,6.849,23.532,13.9,35.669,20.2.613.319.152,1.29-.464.967",
    transform: "translate(-268.842 -192.894)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24758",
    "data-name": "Path 24758",
    d: "M316.921,269.37c-13.05-8.139-26.115-16.255-39.331-24.13-.589-.348-.131-1.322.466-.967,13.215,7.872,26.276,15.99,39.328,24.124.58.362.125,1.339-.462.973",
    transform: "translate(-270.862 -198.668)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24759",
    "data-name": "Path 24759",
    d: "M310.921,256.345c-10.511-5.229-20.885-10.718-31.3-16.14-.611-.325-.152-1.293.464-.975,10.41,5.426,20.787,10.916,31.3,16.147a.537.537,0,0,1-.464.968",
    transform: "translate(-269.618 -201.77)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24760",
    "data-name": "Path 24760",
    d: "M308.284,247.213c-10.184-5.628-21.1-9.667-31.554-14.732a.538.538,0,0,1,.466-.968c10.456,5.067,21.37,9.1,31.549,14.734.6.335.142,1.3-.461.967",
    transform: "translate(-271.406 -206.526)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24761",
    "data-name": "Path 24761",
    d: "M303.58,235.945c-9.9-2.925-19.5-6.7-29.278-9.982-.658-.22-.184-1.187.466-.968,9.684,3.243,19.2,7,29,9.895.653.191.471,1.253-.191,1.056",
    transform: "translate(-272.916 -210.53)",
    fill: "#b97e4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24762",
    "data-name": "Path 24762",
    d: "M302.213,228.984c-10.682-1-20.806-4.381-31.053-7.371-.655-.191-.469-1.248.189-1.057,10.244,2.989,20.374,6.375,31.051,7.376.69.061.495,1.116-.188,1.053",
    transform: "translate(-274.911 -213.263)",
    fill: "#b97e4d"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24764",
    "data-name": "Path 24764",
    d: "M265.851,221.2c-.668,3.74,2.5,8.289,6.239,8.957s9.122-2.354,9.789-6.092-3.332-8.441-7.07-9.109-8.292,2.5-8.958,6.244",
    transform: "translate(629.306 333.807)",
    fill: "#6b4c34"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24765",
    "data-name": "Path 24765",
    d: "M279.491,224.476c-.669,3.74,2.5,8.294,6.241,8.96s9.122-2.352,9.793-6.094-3.334-8.441-7.073-9.11-8.294,2.5-8.96,6.244",
    transform: "translate(637.718 335.831)",
    fill: "#6b4c34"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24766",
    "data-name": "Path 24766",
    d: "M267.219,213.558a18.976,18.976,0,0,0-4.307,9.151,120.526,120.526,0,0,0-22.08,2.782,20.742,20.742,0,0,1,.2-7.342,30.888,30.888,0,0,0-5.392,8.646c-7.562,2.124-14.226,4.991-19.18,8.509,1.528-16.68,8.31-31.349,21.374-38.409a24.672,24.672,0,0,1,5.132,5.988,15.762,15.762,0,0,0-1.717-7.583c7.963-3.24,17.953-3.909,30.159-1.007a43.838,43.838,0,0,1,4.01,10.368,38.5,38.5,0,0,0,1.971-8.609c18.819,7.068,36.914,28.643,38.356,45.4-7.043-13.071-27.15-18.719-48.171-18.811a21.993,21.993,0,0,1-.352-9.086",
    transform: "translate(598.898 319.986)",
    fill: "#9cb560"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24767",
    "data-name": "Path 24767",
    d: "M273.321,202.26a47.828,47.828,0,0,1,15.3,6.95,59.974,59.974,0,0,1,11.117,9.746,64.072,64.072,0,0,1,11.259,17.312,87.274,87.274,0,0,0-12.388-16.253c-6.142-6.258-14.819-12.926-25.816-15.676-10.976-2.773-21.792-1.072-30.07,1.851-8.393,2.844-14.594,6.528-18.564,8.612A78.052,78.052,0,0,1,242.2,204.737c8.305-3.353,19.6-5.393,31.126-2.477",
    transform: "translate(603.646 325.172)",
    fill: "#8a9c4e"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24768",
    "data-name": "Path 24768",
    d: "M273.671,201.3a18.29,18.29,0,0,0-7.98,6.963,173.053,173.053,0,0,0-25.965-5.843,17.662,17.662,0,0,1,2.715-6.834,31.838,31.838,0,0,0-9.044,6.074c-9.28-.9-17.815-.75-24.618.661,7.382-15.118,20.038-26.331,37.236-27.972a25.238,25.238,0,0,1,3.786,7.6,13.485,13.485,0,0,0,.626-7.794c10.121,0,21.671,3.2,34.518,10.6a38.937,38.937,0,0,1,1.027,11.3,33.862,33.862,0,0,0,5.164-7.35c18.924,13.865,32.12,41.111,28.081,57.445-3.552-15-24.428-28.03-48.218-36.17a18.423,18.423,0,0,1,2.674-8.688",
    transform: "translate(594.161 308.704)",
    fill: "#9cb560"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24769",
    "data-name": "Path 24769",
    d: "M280.677,193.621a61.778,61.778,0,0,1,14.986,12.409,67.59,67.59,0,0,1,9.3,13.437,62.389,62.389,0,0,1,6.892,20.614,88.171,88.171,0,0,0-8.53-20.051c-4.841-8.244-12.415-17.851-23.956-24.651-11.5-6.816-24.329-9.367-34.7-9.78-10.477-.538-18.753.553-23.96.994a101.916,101.916,0,0,1,23.858-2.566c10.543.027,24.031,2.433,36.109,9.594",
    transform: "translate(601.52 314.783)",
    fill: "#8a9c4e"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24770",
    "data-name": "Path 24770",
    d: "M259.566,238.012a14.85,14.85,0,0,0,1.2,8.622,147.451,147.451,0,0,0-15.818,15.624,14,14,0,0,1-3.5-4.875,26.263,26.263,0,0,0,.105,8.975c-4.834,6.107-8.6,12.14-10.711,17.518-7.112-11.76-9.125-25.508-2.462-38.257a20.73,20.73,0,0,1,6.978.666,10.74,10.74,0,0,0-5.109-3.84c4.595-7.088,12.046-13.772,23-19.537a31.572,31.572,0,0,1,8.283,4.205,27.385,27.385,0,0,0-2.744-6.81c18.174-7.206,43.009-4.558,52.475,5.4-11.988-4.063-30.469,4.87-46.889,17.97a14.71,14.71,0,0,1-4.8-5.664",
    transform: "translate(603.737 334.644)",
    fill: "#9cb560"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24771",
    "data-name": "Path 24771",
    d: "M261.688,225.292a52.086,52.086,0,0,1,15.383-5.08,56.309,56.309,0,0,1,13.51-.647,50.768,50.768,0,0,1,17.388,4.168,72.022,72.022,0,0,0-17.742-2.776,57.462,57.462,0,0,0-27.912,6.011A63.967,63.967,0,0,0,239.81,246.99a131.253,131.253,0,0,0-10.179,17.2,85.769,85.769,0,0,1,9.046-17.817,61.9,61.9,0,0,1,23.011-21.086",
    transform: "translate(607.022 336.616)",
    fill: "#8a9c4e"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24772",
    "data-name": "Path 24772",
    d: "M329.6,230.664a14.868,14.868,0,0,1,.642,8.684A146.686,146.686,0,0,1,349,251.3a14.083,14.083,0,0,0,2.391-5.508,26.278,26.278,0,0,1,1.795,8.8c6.006,4.952,10.955,10.055,14.151,14.871,4.474-13,3.555-26.858-5.651-37.924a20.743,20.743,0,0,0-6.672,2.121,10.753,10.753,0,0,1,4.183-4.828c-5.985-5.961-14.672-10.933-26.591-14.258a31.3,31.3,0,0,0-7.211,5.856,27.17,27.17,0,0,1,1.25-7.237c-19.286-3.214-43.007,4.6-50.163,16.324,10.866-6.495,30.811-1.652,49.622,7.7a14.776,14.776,0,0,0,3.5-6.545",
    transform: "translate(635.917 332.327)",
    fill: "#9cb560"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24773",
    "data-name": "Path 24773",
    d: "M322.05,218.605a52.316,52.316,0,0,0-16.111-1.728,56.282,56.282,0,0,0-13.346,2.21,50.7,50.7,0,0,0-16.113,7.738,72.065,72.065,0,0,1,16.758-6.451,57.473,57.473,0,0,1,28.554,0,63.949,63.949,0,0,1,26.214,14.837,132.258,132.258,0,0,1,13.574,14.675,86.147,86.147,0,0,0-12.6-15.513,61.887,61.887,0,0,0-26.934-15.771",
    transform: "translate(635.917 335.015)",
    fill: "#8a9c4e"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24774",
    "data-name": "Path 24774",
    d: "M326.49,215.547a19.057,19.057,0,0,1,3.709,9.406,120.635,120.635,0,0,1,21.85,4.2,20.793,20.793,0,0,0,.278-7.335,30.863,30.863,0,0,1,4.823,8.976c7.4,2.609,13.87,5.9,18.589,9.725-.451-16.742-6.27-31.818-18.848-39.7a24.552,24.552,0,0,0-5.512,5.642,15.828,15.828,0,0,1,2.2-7.453c-7.741-3.751-17.665-5.062-30.033-2.959a43.89,43.89,0,0,0-4.661,10.093,38.177,38.177,0,0,1-1.423-8.722c-19.23,5.841-38.681,26.2-41.2,42.836,7.867-12.586,28.3-16.931,49.276-15.663a21.937,21.937,0,0,0,.944-9.042",
    transform: "translate(635.787 321.584)",
    fill: "#9cb560"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24775",
    "data-name": "Path 24775",
    d: "M316.057,203.809a47.789,47.789,0,0,0-15.725,5.946,60.382,60.382,0,0,0-11.72,9.01,64.184,64.184,0,0,0-12.344,16.548,86.85,86.85,0,0,1,13.406-15.422c6.527-5.848,15.621-11.943,26.777-13.975,11.125-2.061,21.813.331,29.883,3.788a115.938,115.938,0,0,1,17.974,9.793,78.154,78.154,0,0,0-17.353-11.209c-8.076-3.882-19.209-6.647-30.9-4.478",
    transform: "translate(635.786 326.521)",
    fill: "#8a9c4e"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24776",
    "data-name": "Path 24776",
    d: "M301.118,203.279a14.555,14.555,0,0,1,8.275,2.247,150.657,150.657,0,0,1,17.626-13.555,13.441,13.441,0,0,0-4.273-4.034,25.9,25.9,0,0,1,8.782,1.216c6.69-3.972,13.152-6.918,18.735-8.315-10.491-8.43-23.666-12.111-37.135-7.17a20.438,20.438,0,0,0-.365,6.92,10.334,10.334,0,0,1-3.014-5.481c-7.613,3.618-15.261,10.087-22.5,20.1a30.4,30.4,0,0,0,2.912,8.638,26.351,26.351,0,0,1-6.278-3.536c-9.707,16.913-10.747,41.578-2.375,52.085-2.228-12.252,9.23-29.247,24.463-43.706a14.129,14.129,0,0,0-4.849-5.41",
    transform: "translate(635.528 307.028)",
    fill: "#9cb560"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24777",
    "data-name": "Path 24777",
    d: "M288.284,203.726a52.931,52.931,0,0,0-7.222,14.443,56.149,56.149,0,0,0-2.608,13.152A49.788,49.788,0,0,0,280,248.874a70.846,70.846,0,0,1-.124-17.724,57.915,57.915,0,0,1,9.969-26.607,65.257,65.257,0,0,1,22.913-19.556,133.777,133.777,0,0,1,18.339-7.836,87.333,87.333,0,0,0-18.775,6.647,63.319,63.319,0,0,0-24.033,19.93",
    transform: "translate(637.035 310.548)",
    fill: "#8a9c4e"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24778",
    "data-name": "Path 24778",
    d: "M271.6,225.216c-.666,3.74,2.5,8.292,6.241,8.962s9.127-2.354,9.791-6.1-3.334-8.439-7.073-9.109-8.291,2.5-8.958,6.242",
    transform: "translate(632.85 336.289)",
    fill: "#86593d"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24779",
    "data-name": "Path 24779",
    d: "M272.025,330.962c-12.4-3.746-17.773-7.5-20.18-9.453a23.867,23.867,0,0,1-2-1.858l-.249-.293a10.92,10.92,0,0,1-3.4-8.5,12.877,12.877,0,0,1,.335-2.411c.094-.548.105-.842.031-.875s-.233.207-.482.723a8.05,8.05,0,0,0-.812,2.449q-.085.429-.179.915,0,.5,0,1.046a8.625,8.625,0,0,0,.039,1.161c.081.4.167.82.251,1.255a13,13,0,0,0,2.905,5.41l.278.323a25.8,25.8,0,0,0,2.165,2.016c2.584,2.1,8.224,5.985,20.79,9.777,6.268,1.885,11.065,2.915,14.661,3.673s6.011,1.153,7.615,1.442l3.219.534c8.878,1.146,13.367,1.2,13.395.909.037-.336-4.375-1.028-13.118-2.643l-3.2-.53c-1.594-.285-3.992-.69-7.56-1.434s-8.32-1.772-14.507-3.631",
    transform: "translate(616.556 390.984)",
    fill: "#effff8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24780",
    "data-name": "Path 24780",
    d: "M340.788,332.8a160.384,160.384,0,0,1-27.624,3.812l-3.985.189c-10.924.477-16.405-.1-16.447.3-.016.158,1.335.432,4.076.81a105.77,105.77,0,0,0,12.423.64l4.026-.188a161.916,161.916,0,0,0,27.921-3.854c15.721-3.736,23.013-7.6,26.609-9.393l3.563-1.939a48.883,48.883,0,0,0,9.686-7.911c1.791-2.144,2.6-3.251,2.48-3.353-.39-.372-3.639,4.291-13.063,9.752l-3.481,1.893c-3.513,1.753-10.648,5.544-26.183,9.237",
    transform: "translate(645.939 393.658)",
    fill: "#effff8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24781",
    "data-name": "Path 24781",
    d: "M338.971,330.916a45.156,45.156,0,0,1-9.822,2.778,8.588,8.588,0,0,1-1.437.21c-3.917.676-5.961.6-6,.975-.045.252,2,.986,6.21.77a9.017,9.017,0,0,0,1.507-.222,46.705,46.705,0,0,0,10.182-2.873,73.173,73.173,0,0,0,9.5-4.554l1.3-.749c3.419-2.331,4.86-3.849,4.685-4.087-.2-.278-2,.708-5.581,2.577l-1.276.729a70.9,70.9,0,0,1-9.269,4.446",
    transform: "translate(663.813 400.575)",
    fill: "#effff8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24782",
    "data-name": "Path 24782",
    d: "M273.594,332.1c-2.154-.36-3.754-.677-4.941-.967-1.2-.244-1.979-.474-2.5-.624l-1.043-.294c-2.905-.632-4.406-.938-4.537-.611-.108.262,1.169,1.172,4.039,2.3l1.077.3c.535.155,1.344.393,2.572.647,1.222.294,2.858.619,5.051.985,4.386.679,6.58.894,7.673,1.036l1.095.129c6.035.244,6.157-.537.205-1.746l-1.091-.128c-1.091-.144-3.28-.357-7.6-1.025",
    transform: "translate(626.103 404.492)",
    fill: "#effff8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24783",
    "data-name": "Path 24783",
    d: "M348.416,305.571l-1.641-1.689c-1.473-.82-2.014-.244-1.259,1.225l1.607,1.654,1.415,1.738c1.35.9,2.063.537,1.408-1.052Z",
    transform: "translate(678.285 388.479)",
    fill: "#effff8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24784",
    "data-name": "Path 24784",
    d: "M76.194,297.7c-.752-.113-1.476-.252-2.186-.333-.719-.039-1.418-.082-2.09-.12a16.051,16.051,0,0,0-3.8.6,29.011,29.011,0,0,0-5.521,2.318c-1.465.774-2.681,1.343-3.693,1.809a17.234,17.234,0,0,1-2.519.833c-.674.133-1.18.231-1.56.3l-.8.045-.338.019a31.2,31.2,0,0,1-8.621-1.554c-1.94-.545-2.959-.718-3-.569s.844.621,2.689,1.449c.928.409,2.1.9,3.56,1.389a19.181,19.181,0,0,0,5.392,1.044l.4-.023c.2-.013.493-.031.936-.055.432-.084,1.007-.194,1.774-.344a18.843,18.843,0,0,0,2.786-.922c1.074-.492,2.349-1.093,3.806-1.861,2.921-1.439,6.769-3.659,12.456-2.306,2,.419,3.992,1.006,6.045,1.555a28.455,28.455,0,0,0,6.431.952l-.063,0c3.678.262,7.347.163,10.942.218,7.967-.121,11.859,1.1,11.964.663.04-.154-.9-.534-2.854-1.132a42.616,42.616,0,0,0-9.078-1.287c-3.667-.057-7.272.04-10.848-.215h-.015l-.049,0a26.758,26.758,0,0,1-5.992-.9c-2-.534-4.032-1.137-6.145-1.578",
    transform: "translate(491.335 384.62)",
    fill: "#effff8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24785",
    "data-name": "Path 24785",
    d: "M208.626,250.52a25.873,25.873,0,0,0-8.278.632c-2.317.535-4.262,1.117-5.895,1.628a57.275,57.275,0,0,1-6.881,1.822,16.775,16.775,0,0,1-2.533.246l-.359.006a17.408,17.408,0,0,1-2.771-.113,20.1,20.1,0,0,1-2.338-.592,19.167,19.167,0,0,1-1.914-.778c-.561-.3-1.064-.568-1.513-.807-1.72-1.1-2.6-1.689-2.721-1.555-.1.1.567.93,2.192,2.325l1.483,1.049a16.738,16.738,0,0,0,1.984,1.041,18.52,18.52,0,0,0,2.537.857,17.441,17.441,0,0,0,3.077.328l.4,0a19.746,19.746,0,0,0,2.771-.268,59.611,59.611,0,0,0,7.1-1.875c1.639-.514,3.531-1.078,5.759-1.594a24.291,24.291,0,0,1,7.68-.6,30.882,30.882,0,0,1,7.385,2.445,35.993,35.993,0,0,0,5.84,2.045,18.691,18.691,0,0,0,4.525.5,19.527,19.527,0,0,0,3.018-.385c1.549-.32,2.278-.563,2.651-.66l.373-.107a46,46,0,0,1,5.172-1.507,14.648,14.648,0,0,1,3.74-.3c2.013.133,3.028.472,3.093.276.045-.1-.847-.752-2.978-1.2a13.134,13.134,0,0,0-4.063-.123,38.261,38.261,0,0,0-5.455,1.171l-.361.105c-.362.094-1.085.328-2.521.627a14.771,14.771,0,0,1-6.8-.1,34.677,34.677,0,0,1-5.555-1.953,32.181,32.181,0,0,0-7.849-2.569",
    transform: "translate(572.349 355.729)",
    fill: "#effff8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24786",
    "data-name": "Path 24786",
    d: "M162.254,291.5a31.479,31.479,0,0,1-12.709.726,57.338,57.338,0,0,0-6.782-.466c-2.909.037-2.909.058-2.909.058l-2.781.461c-.85.189-1.614.445-2.328.64-1.424.412-2.543.85-3.466,1.175-1.825.6-2.736.991-2.7,1.146s1.006.081,2.954-.244c.951-.176,2.144-.485,3.552-.752.707-.123,1.462-.307,2.281-.424l2.632-.252s0-.014,2.753-.05a54.877,54.877,0,0,1,6.627.456,33.381,33.381,0,0,0,13.264-.762,32,32,0,0,1,7.2-1.009,51.038,51.038,0,0,1,5.5.477c3.138.34,5.25.682,6.653.863l2.81.375q2.922.228,5.115.394c1.468.044,2.7,0,3.677-.021,1.96-.06,2.928-.173,2.928-.333s-.968-.364-2.889-.6q-1.438-.16-3.592-.4-2.149-.33-5.01-.773l-2.8-.374c-1.408-.184-3.492-.521-6.69-.87a51.666,51.666,0,0,0-5.694-.488,33.827,33.827,0,0,0-7.581,1.053",
    transform: "translate(544.694 380.423)",
    fill: "#effff8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24787",
    "data-name": "Path 24787",
    d: "M216.767,321.63a34.151,34.151,0,0,0-7.209.309c-2.06.289-3.8.627-5.275.91-2.952.568-4.9.917-6.2,1.049-1.3.181-1.948.171-2.272.209l-.327.021a24.423,24.423,0,0,1-7.954-.571c-1.738-.443-2.632-.708-2.706-.545-.06.123.7.679,2.42,1.437a20.513,20.513,0,0,0,8.323,1.434l.341-.024c.341-.036,1.038-.029,2.386-.218,1.36-.137,3.366-.5,6.32-1.067,2.951-.5,6.852-1.505,12.053-1.188a29.06,29.06,0,0,1,6.747,1.18c1.943.566,3.651,1.08,5.146,1.447a23.352,23.352,0,0,0,6.532.673c1.368-.094,2.06-.126,2.393-.179l.338-.04c3.681-.588,6.3-1.166,8.1-1.245,1.788-.133,2.711-.073,2.742-.265.028-.118-.858-.5-2.736-.669a47.933,47.933,0,0,0-8.3.433,18.391,18.391,0,0,1-2.6.212,21.682,21.682,0,0,1-6.061-.629c-1.429-.349-3.082-.846-5.072-1.426a30.975,30.975,0,0,0-7.127-1.247",
    transform: "translate(579.384 399.614)",
    fill: "#effff8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24788",
    "data-name": "Path 24788",
    d: "M236.749,285.025a97.272,97.272,0,0,1-12.52,1.263,10.48,10.48,0,0,1-1.775,0c-4.865.074-7.314-.437-7.4-.053-.076.228,2.27,1.389,7.363,1.809a11.09,11.09,0,0,0,1.848,0,98.784,98.784,0,0,0,12.719-1.28,74.385,74.385,0,0,1,12.5-.871l1.777.108c4.878.136,7.335.618,7.423.236.07-.233-2.259-1.353-7.3-1.99l-1.845-.11a76.081,76.081,0,0,0-12.787.888",
    transform: "translate(598.027 376.528)",
    fill: "#effff8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24789",
    "data-name": "Path 24789",
    d: "M386.6,285.884c-6.524,1.5-9.757,1.272-11.358,1.1a12.314,12.314,0,0,1-1.392-.217l-.2-.039a18.991,18.991,0,0,1-2.86-.543,16.353,16.353,0,0,1-2.039-.561c-1.088-.327-1.686-.422-1.759-.28s.375.517,1.385,1.137a10.057,10.057,0,0,0,1.976,1,15.872,15.872,0,0,0,2.973.975l.215.037a12.927,12.927,0,0,0,1.507.234c1.709.2,5.326.4,11.917-1.132a48.447,48.447,0,0,1,11.414-1.614l1.622.089a25.962,25.962,0,0,1,2.93.175,20.1,20.1,0,0,1,2.1.262c1.13.154,1.736.155,1.785,0s-.453-.453-1.542-.91a11.3,11.3,0,0,0-2.1-.7,18.693,18.693,0,0,0-3.056-.582l-1.728-.091a50.172,50.172,0,0,0-11.8,1.651",
    transform: "translate(691.738 376.593)",
    fill: "#effff8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24790",
    "data-name": "Path 24790",
    d: "M315.187,367.12a49.727,49.727,0,0,0-12.229,2.023c-1.424.346-2.613.634-3.6.871l-2.411.382a12.89,12.89,0,0,1-2.22.162l-.317.008a23.929,23.929,0,0,1-4.59-.11,21.158,21.158,0,0,1-3.29-.5c-1.757-.319-2.682-.4-2.731-.249s.771.537,2.5,1.156a16.019,16.019,0,0,0,3.316.943,21.646,21.646,0,0,0,4.842.516l.343-.01a13.78,13.78,0,0,0,2.37-.171c.668-.108,1.5-.239,2.55-.4l3.681-.892a48.584,48.584,0,0,1,11.718-1.968,16.559,16.559,0,0,1,6.364,1.707,24.585,24.585,0,0,0,5.133,1.623,59.23,59.23,0,0,0,6.247,1.072l2.66.254a71.92,71.92,0,0,0,8.184-.2c1.808-.154,2.708-.315,2.706-.474s-.9-.315-2.7-.461-4.509-.283-8.063-.619l-2.58-.247a57.261,57.261,0,0,1-6.077-1.041,22.644,22.644,0,0,1-4.816-1.525,18.288,18.288,0,0,0-6.983-1.846",
    transform: "translate(640.429 427.714)",
    fill: "#effff8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24791",
    "data-name": "Path 24791",
    d: "M361.643,352.314a81.824,81.824,0,0,0-9.054,1.8c-2.16.519-3.584.763-4.545.93l-1.919.246a49.613,49.613,0,0,1-5.974.514c-1.348.068-2.042.184-2.058.341s.642.359,2,.593a25.959,25.959,0,0,0,6.215.3l2.01-.255c.988-.171,2.5-.433,4.666-.956a81.193,81.193,0,0,1,8.892-1.77,29.585,29.585,0,0,1,8.892-.042c2.175.284,3.626.556,4.6.728l1.945.351c5.413.768,8.22.545,8.218.252.006-.348-2.637-.749-7.9-1.982l-1.95-.351c-.978-.171-2.446-.448-4.687-.74a31.493,31.493,0,0,0-9.35.044",
    transform: "translate(673.917 418.354)",
    fill: "#effff8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24792",
    "data-name": "Path 24792",
    d: "M150.537,337.865c-7.916,1.34-11.867,1.229-13.8.975a9.906,9.906,0,0,1-1.7-.2l-.239-.044c-.664-.091-1.287-.171-1.869-.251-.576-.108-1.1-.26-1.589-.37s-.947-.217-1.36-.31l-1.08-.365c-1.292-.425-2-.571-2.071-.43s.477.568,1.7,1.29c.307.176.65.39,1.046.585.412.163.865.344,1.361.537s1.036.411,1.633.592c.606.141,1.256.294,1.95.456l.257.049a10.857,10.857,0,0,0,1.8.207c2.048.268,6.263.365,14.249-.993,7.95-1.4,11.88-1.77,13.862-1.775a15.477,15.477,0,0,1,1.725-.024l.246.011c5.4-.108,8.094.645,8.2.234.086-.191-2.5-1.6-8.173-1.993l-.257-.006a15.75,15.75,0,0,0-1.8.023c-2.052,0-6.168.4-14.09,1.8",
    transform: "translate(543.613 408.537)",
    fill: "#effff8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24793",
    "data-name": "Path 24793",
    d: "M243.012,381.583c-.1-12.617-23.993-15.673-43.394-12.03s-11.856,26.276,14.551,25.739,28.9-7.007,28.843-13.709",
    transform: "translate(581.796 428.331)",
    fill: "#daf1e8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24794",
    "data-name": "Path 24794",
    d: "M427.011,331.063c-.07-12.617-16.082-15.673-29.085-12.03s-7.948,26.277,9.752,25.739,19.369-7.005,19.333-13.708",
    transform: "translate(706.318 397.172)",
    fill: "#daf1e8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24795",
    "data-name": "Path 24795",
    d: "M138,255.353c-.116-12.617-26.921-15.673-48.689-12.03s-13.3,26.277,16.326,25.739,32.424-7.005,32.363-13.709",
    transform: "translate(512.945 350.477)",
    fill: "#daf1e8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13204",
    "data-name": "Group 13204",
    transform: "translate(635.467 546.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24433",
    "data-name": "Path 24433",
    d: "M1461.079,1647.133c-1.439-1.44-4.7-8.27-1.743-13.6,3.068-5.537,11.056-6.862,23.747-3.932,12.744,2.941,23.4.541,29.238-6.587a16.47,16.47,0,0,0,2.333-17.328c-6.186-13.66-27.065-19.34-27.275-19.4l1.536-5.789c.971.257,23.848,6.493,31.2,22.714a22.426,22.426,0,0,1-3.155,23.594c-7.333,8.954-20.169,12.1-35.218,8.628-12.95-2.987-16.24-.423-17.051.817-1.385,2.119.183,6.017.748,6.778a1.094,1.094,0,0,0-.117-.131Z",
    transform: "translate(-1458.136 -1580.499)",
    fill: "#544866"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24434",
    "data-name": "Path 24434",
    d: "M1512.039,1568.848c0,5.906,4.022,10.695,8.984,10.695s8.984-4.788,8.984-10.695-4.023-10.695-8.984-10.695S1512.039,1562.941,1512.039,1568.848Z",
    transform: "translate(-857.756 -1019.674)",
    fill: "#6cc5de"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24435",
    "data-name": "Path 24435",
    d: "M1518.369,1568.848c0,5.906,4.023,10.695,8.984,10.695s8.984-4.788,8.984-10.695-4.022-10.695-8.984-10.695S1518.369,1562.941,1518.369,1568.848Z",
    transform: "translate(-861.876 -1019.674)",
    fill: "#60afc5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13205",
    "data-name": "Group 13205",
    transform: "translate(624.039 516.542)"
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24436",
    "data-name": "Path 24436",
    d: "M1443.883,1519.562h-1.714l.6-13.622h.52Z",
    transform: "translate(-1436.314 -1502.229)",
    fill: "#5b5472"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24437",
    "data-name": "Path 24437",
    d: "M1443.017,1524.206l1.105-.374-.016-.369-1.073.363Z",
    transform: "translate(-1436.866 -1513.636)",
    fill: "#bcb8d8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24438",
    "data-name": "Path 24438",
    d: "M1442.521,1536.258l1.475.156-.015-.358-1.444-.153Z",
    transform: "translate(-1436.543 -1521.733)",
    fill: "#bcb8d8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24439",
    "data-name": "Path 24439",
    d: "M1442.842,1528.613l1.237-.177-.016-.355-1.205.172Z",
    transform: "translate(-1436.752 -1516.641)",
    fill: "#bcb8d8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24440",
    "data-name": "Path 24440",
    d: "M1443.607,1511.406l.721.269-.017-.384-.687-.257Z",
    transform: "translate(-1437.251 -1505.545)",
    fill: "#bcb8d8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24441",
    "data-name": "Path 24441",
    d: "M1443.385,1516.514l.872.156-.016-.362-.84-.151Z",
    transform: "translate(-1437.106 -1508.879)",
    fill: "#bcb8d8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24442",
    "data-name": "Path 24442",
    d: "M1443.22,1519.913l.971-.213-.016-.359-.939.205Z",
    transform: "translate(-1436.998 -1510.953)",
    fill: "#bcb8d8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24443",
    "data-name": "Path 24443",
    d: "M1438.82,1547.741H1425.4a4.772,4.772,0,0,1,4.773-4.772h3.878a4.772,4.772,0,0,1,4.773,4.772Z",
    transform: "translate(-1425.397 -1526.333)",
    fill: "#03566f"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24444",
    "data-name": "Path 24444",
    d: "M1442.676,1497.565a2.254,2.254,0,1,1-2.254-2.255A2.255,2.255,0,0,1,1442.676,1497.565Z",
    transform: "translate(-1433.709 -1495.31)",
    fill: "#8277b7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24445",
    "data-name": "Path 24445",
    d: "M1440.642,1501.382a2.254,2.254,0,0,1-2.254-2.254c0-.064.005-.128.01-.19a2.252,2.252,0,1,0,4.268,1.179A2.253,2.253,0,0,1,1440.642,1501.382Z",
    transform: "translate(-1433.709 -1497.672)",
    fill: "#968ece",
    opacity: 0.58,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24446",
    "data-name": "Path 24446",
    d: "M1360.532,1465.215c13.721.754,31.368,16.7,37.239,37.45,5.533,20.6-13.821,41.619-40.844,40.595-27-1.471-44.61-21.226-37.2-41.23C1327.486,1481.908,1346.8,1464.7,1360.532,1465.215Z",
    transform: "translate(-731.468 -959.171)",
    fill: "#facd00"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24447",
    "data-name": "Path 24447",
    d: "M1398.312,1537.4l-13.984-3.917a24.4,24.4,0,0,0-4.254-27.249l4.4-7.846q-.307-.328-.618-.648l-4.407,7.856a23.783,23.783,0,0,0-32.6-.823l-8.489-8.607q-.316.287-.632.579l8.491,8.61a24.416,24.416,0,0,0-6.171,25.593l-21.079,4.553q.069.423.153.842l21.223-4.585a23.9,23.9,0,0,0,43.589,2.5l14.135,3.959Q1398.2,1537.816,1398.312,1537.4Zm-35.6,8.087a22.534,22.534,0,1,1,22.29-22.533A22.436,22.436,0,0,1,1362.711,1545.491Z",
    transform: "translate(-732.083 -979.328)",
    fill: "#68597e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24448",
    "data-name": "Path 24448",
    d: "M1367.248,1548.428c-27-1.472-44.611-21.228-37.2-41.231A68.709,68.709,0,0,1,1340.7,1489a69.937,69.937,0,0,0-20.969,28.519c-7.409,20,10.2,39.759,37.2,41.23,16.41.623,29.992-6.884,36.89-17.489A44.565,44.565,0,0,1,1367.248,1548.428Z",
    transform: "translate(-731.468 -974.66)",
    fill: "#e9a5d0",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13206",
    "data-name": "Group 13206",
    transform: "translate(580.945 538.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24449",
    "data-name": "Path 24449",
    d: "M1326.244,1567.972c0,5.908-4.022,10.7-8.983,10.7s-8.984-4.788-8.984-10.7,4.022-10.694,8.984-10.694S1326.244,1562.065,1326.244,1567.972Z",
    transform: "translate(-1306.067 -1557.277)",
    fill: "#6cc5de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24450",
    "data-name": "Path 24450",
    d: "M1319.913,1567.972c0,5.908-4.022,10.7-8.983,10.7s-8.984-4.788-8.984-10.7,4.022-10.694,8.984-10.694S1319.913,1562.065,1319.913,1567.972Z",
    transform: "translate(-1301.946 -1557.277)",
    fill: "#60afc5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13207",
    "data-name": "Group 13207",
    transform: "translate(610.988 508.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24451",
    "data-name": "Path 24451",
    d: "M1432.251,1477.292a2.881,2.881,0,1,1,2.851-2.881A2.866,2.866,0,0,1,1432.251,1477.292Z",
    transform: "translate(-1414.952 -1471.529)",
    fill: "#ff0303"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24452",
    "data-name": "Path 24452",
    d: "M1407.65,1555.751a19.847,19.847,0,1,1,19.64-19.846A19.743,19.743,0,0,1,1407.65,1555.751Z",
    transform: "translate(-1388.011 -1500.515)",
    fill: "#0c0c0c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24453",
    "data-name": "Path 24453",
    d: "M1411.883,1557.735a17.552,17.552,0,1,1,17.369-17.551A17.46,17.46,0,0,1,1411.883,1557.735Z",
    transform: "translate(-1392.244 -1504.794)",
    fill: "#03566f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24454",
    "data-name": "Path 24454",
    d: "M1420,1561.54a13.152,13.152,0,1,1,13.015-13.151A13.084,13.084,0,0,1,1420,1561.54Z",
    transform: "translate(-1400.364 -1512.998)",
    fill: "#2be5f9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_791",
    "data-name": "Ellipse 791",
    cx: 6.888,
    cy: 6.961,
    rx: 6.888,
    ry: 6.961,
    transform: "translate(21.601 31.641)",
    fill: "#fff",
    opacity: 0.57
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13208",
    "data-name": "Group 13208",
    transform: "translate(546.392 488.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24455",
    "data-name": "Path 24455",
    d: "M1222.2,1485.078a22.176,22.176,0,0,1-8.3-1.464,16.805,16.805,0,0,1-9.635-10.217c-2.883-7.673-.865-16.993,5.14-23.743,4.195-4.715,9.413-6.7,14.46-8.622,4.442-1.69,8.636-3.287,11.708-6.684,2.351-2.6,4.514-7.234,3.89-10.7a4.551,4.551,0,0,0-2.591-3.432,2.994,2.994,0,0,1,2.764-5.313,10.515,10.515,0,0,1,5.722,7.685c1.018,5.659-2.056,12.147-5.342,15.781-4.037,4.465-9.112,6.4-14.019,8.263-4.575,1.741-8.9,3.385-12.115,7-4.476,5.031-6.087,12.126-4.009,17.656a10.905,10.905,0,0,0,6.257,6.765c6.17,2.473,16.227.511,29.077-5.679a2.995,2.995,0,0,1,2.6,5.4C1237.7,1482.637,1229.132,1485.078,1222.2,1485.078Z",
    transform: "translate(-1202.962 -1414.562)",
    fill: "#584c6b"
  }))), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24456",
    "data-name": "Path 24456",
    d: "M1435.259,1754.1s-5.455,2.995-6.1,6.31,5.454,8.89,5.454,8.89.591-6.38,1.711-7.5c.833-.832,5.313-2.567,5.313-2.567s6.238,2.032,8.377,4.171a5.37,5.37,0,0,1,1.283,5.027s6.417-2.139,5.775-5.776-6.524-7.807-6.524-7.807,4.813-.855,5.882,1.284c0,0-1.177-6.524-6.417-7.165s-8.128.963-8.128.963a12.383,12.383,0,0,0-6.1-3.422c-3.529-.641-7.594,6.1-7.594,6.1S1433.708,1752.554,1435.259,1754.1Z",
    transform: "translate(-803.183 -1142.253)",
    fill: "#584c6b"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24457",
    "data-name": "Path 24457",
    d: "M1454.8,1751.167a7.1,7.1,0,0,0-3.72-2.93,15.478,15.478,0,0,0-9.1.58,13.179,13.179,0,0,0-3.392-2.378c-3.143-1.506-4.958-1.326-7.923,1.986A21.489,21.489,0,0,0,1428.2,1752a25.783,25.783,0,0,1,2.76-3.3c3.127-3.1,5.165-3.841,10.836,1.136a14.127,14.127,0,0,1,6.875-1.212c3.182.1,6.155,1.312,7.763,6.9A11.3,11.3,0,0,0,1454.8,1751.167Z",
    transform: "translate(-803.183 -1141.644)",
    fill: "#a590c9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24458",
    "data-name": "Path 24458",
    d: "M1284.537,1392.395s3.881-4.864,3.2-8.171-8.457-6.105-8.457-6.105,1.91,6.115,1.308,7.581c-.448,1.088-3.915,4.414-3.915,4.414s-6.54.526-9.337-.624a5.372,5.372,0,0,1-3.12-4.146s-5.1,4.445-3.106,7.554,9.026,4.694,9.026,4.694-4.113,2.642-5.923,1.08c0,0,3.6,5.568,8.681,4.143s7.131-4.018,7.131-4.018a12.386,12.386,0,0,0,6.943.813c3.5-.767,4.661-8.55,4.661-8.55S1286.566,1393.229,1284.537,1392.395Z",
    transform: "translate(-694.118 -902.485)",
    fill: "#584c6b"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_13209",
    "data-name": "Group 13209",
    transform: "translate(566.184 475.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24459",
    "data-name": "Path 24459",
    d: "M1318.648,1379.924a21.668,21.668,0,0,0-4.629-1.8c8.749,4.36,10.266,6.136,5.26,14.276a16.229,16.229,0,0,0,2.83-4.094C1323.79,1384.862,1323.264,1382.322,1318.648,1379.924Z",
    transform: "translate(-1295.043 -1378.119)",
    fill: "#a590c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24460",
    "data-name": "Path 24460",
    d: "M1289,1415.817c1.631.706,5.115-.342,6.78-.966-.6,2.95-2.037,7.588-5.01,7.9a12.392,12.392,0,0,1-6.4-1.051,11.408,11.408,0,0,1-3.791,2.871c-4.235,2.1-7.579,2.387-11.187-1.91,1.6.387,3.841-.73,5.2-1.652-5.131,2.842-5.9.646-7.1-.279a15.489,15.489,0,0,0,4.315,4.827c2.438,1.655,4.6,1.466,6.933.633a15.191,15.191,0,0,0,5.849-3.473c2.247.866,6.881,1.53,8.424-.13,2.346-2.094,2.923-6.38,3.361-8.491C1296.383,1414.1,1290.912,1416.466,1289,1415.817Z",
    transform: "translate(-1264.763 -1401.541)",
    fill: "#a590c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24461",
    "data-name": "Path 24461",
    d: "M1263.571,1398.815a11.7,11.7,0,0,0-3.262,3.585c-2.783,5.063,3.934,7.964,9.182,8.663C1258.6,1407.213,1258.7,1404.353,1263.571,1398.815Z",
    transform: "translate(-1259.658 -1391.59)",
    fill: "#a590c9"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24462",
    "data-name": "Path 24462",
    d: "M1465.337,1765.189c0,1.451-1.711,2.627-3.822,2.627s-3.822-1.176-3.822-2.627,1.712-2.628,3.822-2.628S1465.337,1763.738,1465.337,1765.189Z",
    transform: "translate(-822.38 -1152.728)",
    fill: "#433a52"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24463",
    "data-name": "Path 24463",
    d: "M1308.524,1421.617c.218.96-1.272,2.116-3.327,2.581s-3.9.065-4.114-.9,1.271-2.116,3.326-2.581S1308.307,1420.657,1308.524,1421.617Z",
    transform: "translate(-720.426 -930.09)",
    fill: "#a590c9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingGraphic);
export default __webpack_public_path__ + "static/media/loading-graphic.e73f69c68a9ad0d16111146055116fbd.svg";
export { ForwardRef as ReactComponent };